import { render, staticRenderFns } from "./AppBuffetReceipt.vue?vue&type=template&id=74e94f5c&"
import script from "./AppBuffetReceipt.vue?vue&type=script&lang=js&"
export * from "./AppBuffetReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports